/*@ngInject*/
const ChangePasswordController = function ($rootScope, $scope, $location, $state, $stateParams, $window, coreConstant, coreMediator, loadingBarHandler, refreshLoginTokenUtil, authenticationMediator, localization) {

    localization.setupLocale('auth', require('./changePassword.i18n.json'));

    $scope.viewModel = {
        loginToken: $location.search().token,
        sourceClient: $location.search().source,
        userType: $location.search().userType,
        revisionNumber: '',
        username: $stateParams.username,
        oldPassword: $stateParams.oldPassword,
        messageKey: $stateParams.messageKey
    };

    coreMediator.getRevision().then((result) => {
        $scope.viewModel.revisionNumber = result.revNumber;
    });

    $scope.validateFields = () => {
        return $scope.viewModel.username &&
            $scope.viewModel.newPassword &&
            $scope.viewModel.verifyPassword &&
            $scope.viewModel.newPassword === $scope.viewModel.verifyPassword;
    };

    $scope.isVerifyPasswordFieldInvalid = () => {
        return !$scope.isVerifyPasswordFieldFocused && !$scope.isNewPasswordFieldFocused &&
            $scope.viewModel.newPassword !== '' &&
            $scope.viewModel.verifyPassword !== '' &&
            $scope.viewModel.newPassword !== $scope.viewModel.verifyPassword;
    };

    $scope.changePassword = () => {
        let username = $scope.viewModel.username,
            loginToken = $scope.viewModel.loginToken,
            newPassword = $scope.viewModel.newPassword,
            oldPassword = $scope.viewModel.oldPassword;


        let onSuccess = (newLoginToken) => {
            loadingBarHandler.hideLoadingBar();
            if (!_.isNil(newLoginToken) && ($scope.viewModel.sourceClient === 'html' || !$scope.viewModel.sourceClient)) {
                coreMediator.setLoginToken(newLoginToken);
                refreshLoginTokenUtil.start(newLoginToken).then(function () {
                    $rootScope.$broadcast(coreConstant.event.BOOT_APPLICATION);
                });
            } else {
                $window.location.href = '../';
            }
        };

        let onError = () => {
            $scope.viewModel.newPassword = '';
            $scope.viewModel.verifyPassword = '';
            $scope.viewModel.oldPassword = '';
            $scope.viewModel.username = '';
        };

        loadingBarHandler.showLoadingBar('changePassword.loadingBar');
        authenticationMediator.changePasswordAndLogin(username, (loginToken ? loginToken : oldPassword), newPassword, coreConstant.authorization.INITIAL_TOKEN_TIMEOUT_SECONDS, !_.isEmpty(loginToken)).then(onSuccess, onError);

    };

    $scope.onConfirm = () => {
        $scope.$close();
    };

    $scope.onCancel = () => {
        $scope.$dismiss();
    };

};

angular.module('gw-um-auth')
    .controller('changePasswordController', ChangePasswordController);
